import React from 'react'
import { faAdd } from '@fortawesome/free-solid-svg-icons'
import {
  createOrderConsignment,
  deleteConsignment,
} from 'client/utils/api-routes-orders'
import {
  $DCprimaryColor,
  DcButton,
  PixelDate,
  PixelFactoryContext,
  PixelFlexBox,
  PixelHeaderPanel,
  PixelIcon,
  PixelLeftPanel,
  PixelRightPanel,
  PixelTag,
  PixelText,
  DcOverlaySlider,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../../decl.d'
import OrdersCreateBulkConsignments from '../../components/OrdersCreateBulkConsignments'
interface Address {
  first_name: string
  last_name: string
  customer_reference: string
  phone: string
  email: string
  address1: string
  city: string
  country: string
  country_code: string
  state: string
  state_code: string
  postcode: string
}

interface Meta {
  added_by: string
  sale_by_id: string
  sale_by: string
  order_source: string
}

interface Courier {
  courier_name: string
  tracking_id: string
}

interface Payment {
  payment_id: string
  gateway_id: string
  payment_gateway_name: string
  customer_payment_method_id: string | null
  customer_payment_method_name: string | null
  payment_method_type: string | null
  amount: string
  financial_status: string
  created_at: string
  created_by_name: string | null
  name_on_account: string | null
}

interface LineItem {
  order_id: number
  quantity: number
  product_id: number
  variation_id: number
  price: number
  total: number
  sku: string
  image: string | null
  weight: number
  description: string | null
  line_item_id: number
  name: string
  is_partial_return: boolean | null
  has_properties: boolean | null
  fulfillment_order_id: number
  fulfillment_order_line_item_id: number
}

interface OrderHistory {
  order_id: number
  updated_value: string
  change_type: string
  user_name: string
  update_time: string
  is_bulk: boolean
  message: string
}
interface OrderTag {
  rn: string
  ems_customer_id: string
  order_id: string
  tag_name: string
  date_created: string
  date_updated: string | null
  status: string
  user_id: string | null
}

interface CourierTransaction {
  tracking_id: string
  weight: string
  courier_id: string
  cod_amount: string
  delivery_status: string
  created_at: string
  courier_name: string
  dispatch_time: string | null
  courier_reference: string | null
  dispatch_status: string | null
}

interface MetaOrder {
  invoice_id: string
  invoice_status: string
  is_billing_address_same: boolean
  customer_id: number
  is_editable: boolean
  shipping: Address
  billing: Address
  total: number
  weight: number
  order_discount: number
  complaint_count: number
  source_order_id: number
  split_source_order_id: string
  store_order_id: number
  store_id: number
  store_name: string
  status: string
  tags: string
  number: number
  created_via: string
  last_comment: string
  date_created: string
  is_refuser: boolean
  is_returning: boolean
  is_duplicate: boolean
  dispatch_id: number
  is_split_child: boolean
  is_split_main: boolean
  split_child_ids: string
  split_main_id: string
  exchanged_from_order_id: string
  print_customer_note_on_shipping_label: boolean
  print_customer_note_on_invoice: boolean
  meta: Meta
  courier: Courier
  payments: Payment[]
  order_notes: any[]
  order_tags: OrderTag[]
  courier_transactions: CourierTransaction[]
  line_items: LineItem[]
  order_history: OrderHistory[]
  discount_lines: any[]
  order_shipping: any[]
  order_tax: any[]
  daraz_payment_transactions: any[]
}

interface IProps {
  detailID: number
  order: MetaOrder
  setDetails: (data: MetaOrder) => void
  setReload: (data: boolean) => void
}

const Consignment = (props: IProps) => {
  const {
    pixelConfirm,
    showFailure,
    showSuccess,
    showPageLoader,
    hidePageLoader,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const { order, detailID, setDetails, setReload } = props

  const [currentConsignment, setCurrentConsignment] = React.useState<
    CourierTransaction[]
  >([])

  const [trackingID, setTrackingID] = React.useState<string | null>(null)
  const [cancelForceFully] = React.useState(false)
  const [showAddConsignmentPopup, setShowAddConsignmentPopup] =
    React.useState(false)

  React.useEffect(() => {
    if (order?.courier_transactions) {
      setCurrentConsignment(order?.courier_transactions)
    }
  }, [order])
  const handleDeleteConsignment = () => {
    pixelConfirm({
      title: 'Conformation',
      message: 'Do you want to cancel the consignment ? ',
      onConfirm: () => {
        showPageLoader()
        deleteConsignment(detailID, trackingID, cancelForceFully).subscribe(
          (res: any) => {
            const response = res as AjaxResponse<{
              success: string
              message: string
            }>
            hidePageLoader()
            if (response.response.success) {
              showSuccess(response.response.success)
              setCurrentConsignment([])
              setTrackingID(null)
              setReload(true)
            } else {
              showFailure(response.response.message)
            }
          },
        )
      },
    })
  }
  React.useEffect(() => {
    setTrackingID(
      order?.courier_transactions?.length > 0
        ? order?.courier_transactions[0]?.tracking_id
        : null,
    )
  }, [order])

  return (
    <PixelFlexBox flexDirection="column">
      {currentConsignment?.length > 0 ? (
        <PixelFlexBox
          flexDirection="column"
          alignContent="center"
          padding="10px 0px"
          style={{
            borderBottom: '1px solid #e6e6e6',
          }}
        >
          <PixelHeaderPanel>
            <PixelText
              textSize="16px"
              style={{
                color: 'rgba(0, 0, 0, 0.84)',
                fontWeight: '600',
                padding: '10px',
              }}
            >
              Shipping Information
            </PixelText>
          </PixelHeaderPanel>
          <InnerSectionContent>
            <StandardText>
              Shipped By:&nbsp;
              <PixelTag>{currentConsignment[0]?.courier_name}</PixelTag>
            </StandardText>
            <StandardText>
              Tracking #:&nbsp;
              {currentConsignment[0]?.tracking_id}
            </StandardText>
            <StandardText>
              Delivery Status:&nbsp;
              <strong>{currentConsignment[0]?.delivery_status}</strong>
            </StandardText>
            <StandardText>
              COD Amount: &nbsp;
              <strong>{currentConsignment[0]?.cod_amount}</strong>
            </StandardText>
            <StandardText>
              Booking Date &nbsp;
              <strong>
                <PixelDate
                  className="textSmall"
                  value={currentConsignment[0]?.created_at}
                  format={'dateWithTime'}
                />
              </strong>
            </StandardText>
            <StandardText>
              Payment Status: &nbsp;
              <strong>
                {currentConsignment[0]?.courier_payment_status || 'Unpaid'}
              </strong>
            </StandardText>
            <StandardText>
              Weight: &nbsp; <strong>{currentConsignment[0]?.weight}</strong>
            </StandardText>
          </InnerSectionContent>
          <PixelRightPanel justifyContent="flex-end" padding="10px" gap="10px">
            {order?.is_editable && (
              <DcButton
                disabled={order?.is_editable === false}
                size={'sm'}
                onClick={() => {
                  handleDeleteConsignment()
                }}
              >
                Cancel
              </DcButton>
            )}
          </PixelRightPanel>
        </PixelFlexBox>
      ) : (
        <PixelFlexBox
          flexDirection="column"
          alignContent="center"
          padding="10px 0px"
          style={{
            borderBottom: '1px solid #e6e6e6',
          }}
        >
          <PixelHeaderPanel
            justifyContent="flex-end"
            gap="10px"
            padding="10px 8px 10px 10px"
            style={{
              marginRight: '15px',
              cursor: 'pointer',
            }}
          >
            <PixelText
              textSize="16px"
              color="rgba(0, 0, 0, 0.84)"
              style={{ fontWeight: '600' }}
            >
              Consignment
            </PixelText>

            <PixelLeftPanel>
              {order?.invoice_id ? (
                <>
                  {order?.invoice_status === 'open' ? (
                    <DcButton
                      style={{ padding: '0px' }}
                      size="sm"
                      variant="link"
                      onClick={() => {
                        setShowAddConsignmentPopup(true)
                      }}
                    >
                      <PixelIcon
                        color={$DCprimaryColor}
                        icon={faAdd}
                        tooltip="Add Consignment"
                        showTooltip
                      />{' '}
                    </DcButton>
                  ) : (
                    <DcButton
                      size="sm"
                      variant="link"
                      style={{
                        padding: '0px',
                        border: 'none',
                        cursor: 'not-allowed',
                      }}
                    >
                      <PixelIcon
                        color={$DCprimaryColor}
                        icon={faAdd}
                        tooltip="Add Consignment"
                        showTooltip
                      />
                    </DcButton>
                  )}
                </>
              ) : (
                <DcButton
                  size="sm"
                  variant="link"
                  style={{
                    padding: '0px',
                  }}
                  onClick={() => {
                    setShowAddConsignmentPopup(true)
                  }}
                >
                  <PixelIcon
                    color={$DCprimaryColor}
                    icon={faAdd}
                    tooltip="Add Consignment"
                    showTooltip
                  />
                </DcButton>
              )}
            </PixelLeftPanel>
          </PixelHeaderPanel>
          <InnerSectionContent gap={'10px'}>
            <StandardText>No consignment has been added yet.</StandardText>
          </InnerSectionContent>
        </PixelFlexBox>
      )}
      {showAddConsignmentPopup && (
        <DcOverlaySlider
          title={'Create consignment'}
          width={'70%'}
          onClose={() => setShowAddConsignmentPopup(false)}
          isOpen={showAddConsignmentPopup}
        >
          {showAddConsignmentPopup && (
            <OrdersCreateBulkConsignments
              handleClose={() => setShowAddConsignmentPopup(false)}
              onCreateConsignment={(data) => {
                showPageLoader()

                createOrderConsignment(order.number, data).subscribe(
                  (res: AjaxResponse<any>) => {
                    const response = res as AjaxResponse<{
                      success: string
                      message: string
                      data: {
                        dispatch_id: string
                      }
                      error: {
                        error: string
                      }
                      consignments: {
                        error: string
                      }
                    }>
                    hidePageLoader()
                    setShowAddConsignmentPopup(false)
                    if (response.response.data) {
                      showSuccess(
                        data.is_dispatch
                          ? `Consignment created successfully with Dispatch ID ${response.response.data?.dispatch_id} `
                          : 'Consignment created successfully',
                      )
                      setReload(true)
                      setDetails(response.response.data as any as MetaOrder)
                      setReload(true)
                    } else if (response.response?.error) {
                      showFailure(
                        response.response?.error?.error ||
                          response.response?.error,
                      )
                    } else {
                      showFailure(
                        response.response?.consignments?.error ||
                          'Something went wrong',
                      )
                    }
                  },
                )
              }}
              selectedOrders={order?.invoice_id ? [order?.customer] : [order]}
              isMustDispatch={false}
            />
          )}
        </DcOverlaySlider>
      )}
    </PixelFlexBox>
  )
}

const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
  margin: 10px;
`
const StandardText = styled.div<{ color?: string }>`
  display: inline-flex;
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`

export default Consignment
